export default class Residences {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
        this.urlParams = "";
        this.trigger = document.querySelector(".js-load-residences");
        this.container = document.querySelector(".js-residences-container");
        this.filters = document.querySelectorAll(".js-residences-filter");

        this.offset = 20; /* first 20 */
        this.limit = 12;

        if (
            !this.baseUrl ||
            !this.trigger ||
            !this.container ||
            !this.filters.length
        ) {
            return;
        }

        this.triggerLabel = this.trigger.innerHTML;

        this.loadMoreResidences = this.loadMoreResidences.bind(this);
        this.loadNewResidences = this.loadNewResidences.bind(this);
        this.createQueryURL = this.createQueryURL.bind(this);

        this.filterNames = [];
        this.basisFilters = [];

        this._setDOMReferences();
    }

    _setDOMReferences() {
        this.trigger.addEventListener("click", this.loadMoreResidences);

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        for (let i = 0; i < this.filters.length; i++) {
            const element = this.filters[i];
            element.addEventListener("change", () => this.loadNewResidences());

            const type = element.type;
            const name = element.name;
            const param = urlParams.get(name);

            this.filterNames.push(name);
            if (param) {
                switch (type) {
                    case "select-one":
                        element.value = param;
                        break;
                    case "checkbox":
                        element.checked = true;
                        break;
                    case "text":
                        element.value = param;
                        break;
                    default:
                        break; // do nothing
                }
            }
        }

        for (const [key, value] of urlParams.entries()) {
            if (this.filterNames.includes(key)) continue;
            this.basisFilters.push({
                key,
                value,
            });
        }
    }

    createQueryURL() {
        let url = "";

        const activeFilters = [...this.basisFilters];

        for (let i = 0; i < this.filters.length; i++) {
            const filter = this.filters[i];

            switch (filter.type) {
                case "select-one":
                    if (filter.value) {
                        activeFilters.push({
                            key: encodeURIComponent(filter.name),
                            value: encodeURIComponent(filter.value),
                        });
                    }
                    break;
                case "checkbox":
                    if (filter.checked) {
                        activeFilters.push({
                            key: encodeURIComponent(filter.value),
                            value: 1,
                        });
                    }
                    break;
                case "text":
                    if (filter.value) {
                        activeFilters.push({
                            key: encodeURIComponent(filter.name),
                            value: encodeURIComponent(filter.value),
                        });
                    }
                    break;
                default:
                    break; // do nothing
            }
        }

        Object.keys(activeFilters).forEach((filterKey, index) => {
            const filter = activeFilters[filterKey];
            url += index == 0 ? "?" : "&";
            url += filter.key + "=" + filter.value;
        });

        this.urlParams = url;
        return;
    }

    loadNewResidences() {
        this.createQueryURL();

        this.container.innerHTML = "";
        this.trigger.disabled = true;
        this.trigger.style.display = "inline-block";
        this.trigger.innerHTML = "Even geduld";

        const xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (xhttp.readyState === 4) {
                if (xhttp.status === 200) {
                    let domparser = new DOMParser();
                    const data = domparser.parseFromString(
                        xhttp.responseText,
                        "text/html"
                    );

                    const cells = data.querySelectorAll(".layout__cell");
                    if (cells.length) {
                        for (let i = 0; i < cells.length; i++) {
                            const element = cells[i];
                            this.container.appendChild(element);
                        }

                        if (cells.length < 21) {
                            this.trigger.style.display = "none";
                        } else {
                            this.trigger.style.display = "inline-block";
                            this.trigger.disabled = false;
                            this.trigger.innerHTML = this.triggerLabel;
                        }
                    } else {
                        this.trigger.style.display = "none";
                        let message = document.createElement("div");
                        message.classList.add(
                            "layout__cell",
                            "layout__cell--fit",
                            "unit-1-1"
                        );
                        message.innerHTML = "Geen resultaten gevonden";
                        this.container.appendChild(message);
                    }

                    this.offset = 21; /* default cta is not included */

                    // update url
                    history.pushState("", "", this.baseUrl + this.urlParams);

                    // TODO: Verplaatsen naar losse functie: Duplicate code

                    // Function to format price according to Dutch standards
                    function formatPrice(price) {
                        // Create an Intl.NumberFormat instance for Dutch locale
                        const formatter = new Intl.NumberFormat("nl-NL", {
                            style: "currency",
                            currency: "EUR",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        });

                        // Format the price
                        const formattedPrice = formatter.format(price);

                        return formattedPrice;
                    }

                    // Select all elements with the class 'js-calculateprice'
                    const priceElements =
                        document.querySelectorAll(".js-calculateprice");

                    // Loop through each element
                    priceElements.forEach((element) => {
                        // Get the data-price and data-mutation attributes
                        const basePrice = parseFloat(
                            element.getAttribute("data-price")
                        );
                        const mutation = parseFloat(
                            element.getAttribute("data-mutation")
                        );

                        // Calculate the new price
                        const newPrice = basePrice * mutation;

                        // Format the new price and update the text content of the element
                        element.textContent = formatPrice(newPrice);
                    });
                } else {
                    console.log("geen status 200");
                }
            }
        }.bind(this);

        xhttp.open("GET", this.baseUrl + this.urlParams, true);
        xhttp.setRequestHeader("x-requested-with", "XMLHttpRequest");
        xhttp.send();
    }

    loadMoreResidences() {
        this.createQueryURL();

        this.trigger.disabled = true;
        this.trigger.innerHTML = "Even geduld";

        const xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (xhttp.readyState === 4) {
                if (xhttp.status === 200) {
                    let domparser = new DOMParser();
                    const data = domparser.parseFromString(
                        xhttp.responseText,
                        "text/html"
                    );

                    const cells = data.querySelectorAll(".layout__cell");

                    if (cells.length) {
                        for (let i = 0; i < cells.length; i++) {
                            const element = cells[i];
                            this.container.appendChild(element);
                        }
                    }

                    if (cells.length < this.limit) {
                        this.trigger.style.display = "none";
                    } else {
                        this.trigger.disabled = false;
                        this.trigger.innerHTML = this.triggerLabel;
                    }

                    this.offset += this.limit;
                } else {
                    console.log("geen status 200");
                }
            }
        }.bind(this);

        xhttp.open(
            "GET",
            this.baseUrl +
                "pagination/" +
                this.offset +
                "/" +
                this.limit +
                this.urlParams,
            true
        );
        xhttp.setRequestHeader("x-requested-with", "XMLHttpRequest");
        xhttp.send();
    }
}
